module.exports = __webpack_public_path__ + "1600f55d3d4510f13efc432c26b56df9.png";